export * from './lib/pages/abteilungen/abteilungen.component';
export * from './lib/statusabfrage.providers';
// export * from './lib/statusabfrage.shared';
export * from './lib/statusabfrage.routes';

export * from './lib/pages/mitarbeiter-detail/mitarbeiter-detail.component';